import { SnipingOpportunitiesCard } from './components/SnipingOpportunitiesCard';
import config from 'config';
import TelegramChannels from './components/TelegramChannels';
import { Wallets } from './components/Wallets';
import { TelegramCalls } from './components/TelegramCalls';
import { HotTokens } from './components/HotTokens';
import { SmartSwaps } from './components/SmartSwaps';
import PageTemplate from '../components/layout';
import {
  MAIN_INFO,
  RESEARCH_SIDEBAR,
  Tabs,
} from '../components/layout/SIDEBAR_CONST';
import { useParams } from 'react-router-dom';
import { useGlobalChain } from 'modules/routing/chainProvider';
import {
  ArrowsPointingInIcon,
  ArrowsPointingOutIcon,
} from '@heroicons/react/24/outline';
import Button from 'modules/shared-components/button/button';
import { useResearchSettings } from 'modules/routing/mainSettingsProvider';

export default function Research() {
  const [selectedChain] = useGlobalChain();
  const { researchSettings, setIsTableExpanded } = useResearchSettings();

  const { tab: activeTab } = useParams<{ tab: Tabs }>();
  return (
    <PageTemplate
      sidebar={RESEARCH_SIDEBAR(selectedChain)}
      mainInfo={MAIN_INFO.research.filter(
        (info) => info.activeTab === activeTab
      )}
      buttonContainerClass="xxs:flex xxs:justify-between items-center"
      button={
        <Button
          onClick={() => setIsTableExpanded(!researchSettings.isTableExpanded)}
          className="xxs:px-2 lg:hidden"
          variant="dexNeutral"
          type="button"
        >
          {researchSettings.isTableExpanded ? (
            <ArrowsPointingInIcon className="w-4 h-4" />
          ) : (
            <ArrowsPointingOutIcon className="w-4 h-4" />
          )}
        </Button>
      }
      className="lg:px-1"
      pages={[
        ...(config.isTelegramBrowser
          ? [
              {
                href: '/dex/navigation',
                name: 'Navigation',
              },
            ]
          : []),
        {
          href: '/dex/snipe',
          name: 'Research',
        },
      ]}
    >
      <div className="w-full xxs:space-y-0 lg:space-y-1 xxs:pb-6 lg:pb-0">
        {activeTab === Tabs.Wallets && <Wallets />}
        {activeTab === Tabs.TelegramCalls && <TelegramCalls />}
        {activeTab === Tabs.NewPools && <SnipingOpportunitiesCard />}
        {activeTab === Tabs.TelegramChannels && <TelegramChannels />}
        {activeTab === Tabs.HotTokens && <HotTokens />}
        {activeTab === Tabs.SmartSwaps && <SmartSwaps />}
      </div>
    </PageTemplate>
  );
}
